import React from "react"
import {Link} from 'gatsby'
import ScrollAnimation from 'react-animate-on-scroll';

const Skills = () => (
  <div className="row skills-container">
    <div className="col-md-6">
      <p style={{color:"#ff4a57"}}>I'M EXPERT ON</p>
      <h2 style={{color:"#fff",fontWeight:"bold"}}>Let's Work Together</h2>
      <p style={{color:"#dfdfdf"}}>I'm good at MERN Stack Web Development and having extensive experience of 6 years in affiliate marketing. Let's work together on a project and share our knowledge with each other.</p>
      <ul style={{marginLeft:"0px"}}>
      <li className="list-inline-item"><Link className="skills-button" to="/contact">Hire Me Now</Link></li>
      </ul>
    </div>
    <div className="col-md-6">
    <div class="elementor-widget-container">
      <h2 style={{color:"#fff",fontWeight:"bold"}} id="skills">Skills</h2>
      <div style={{color:"#a7bbc7"}}>
        <p>Programming Languages</p>
        <ScrollAnimation
           animateIn="fadeInRight"
           animateOnce="true"
           duration={1.7}
           delay={0}
         >
        <ul className="list-inline social" style={{color:"#fff", margin:"0px"}}>
          <li className="list-inline-item"><span>JavaScript</span></li>
          <li className="list-inline-item"><span>C++</span></li>
          <li className="list-inline-item"><span>Python</span></li>
          <li className="list-inline-item"><span>HTML / CSS</span></li>
        </ul>
        </ScrollAnimation>

        <p>Frameworks</p>
        <ScrollAnimation
           animateIn="fadeInRight"
           animateOnce="true"
           duration={1.7}
           delay={0}
         >
        <ul className="list-inline social" style={{color:"#fff", margin:"0px"}}>
          <li className="list-inline-item"><span>ReactJS</span></li>
          <li className="list-inline-item"><span>NodeJS</span></li>
          <li className="list-inline-item"><span>Express</span></li>
        </ul>
        </ScrollAnimation>

        <p>CMS</p>
        <ScrollAnimation
           animateIn="fadeInRight"
           animateOnce="true"
           duration={1.7}
           delay={0}
         >
        <ul className="list-inline social" style={{color:"#fff", margin:"0px"}}>
          <li className="list-inline-item"><span>Wordpress</span></li>
        </ul>
        </ScrollAnimation>

        <p>Non-Technical</p>
        <ScrollAnimation
           animateIn="fadeInRight"
           animateOnce="true"
           duration={1.7}
           delay={0}
         >
        <ul className="list-inline social" style={{color:"#fff", margin:"0px"}}>
          <li className="list-inline-item"><span>Affiliate Marketing</span></li>
          <li className="list-inline-item"><span>Digital Marketing</span></li>
          <li className="list-inline-item"><span>SEO</span></li>
        </ul>
        </ScrollAnimation>
      </div>

      </div>
    </div>
  </div>
)

export default Skills
